export default __webpack_public_path__ + "static/media/beta.a19b6a3e.png";